const sortByOrder = (a, b) => a.order - b.order;

export default sortByOrder;
